import router from './router'
import request from '@/lib/request/request'
import Vue from 'vue'
import store from '@/store/index'
import { privilegeInfoByClientId, getSimpleDictByType, decision } from '@/api/base'

router.beforeEach(async(to, from, next) => {
  const { token } = to.query || {}
  if (token) {
    webBridge.setUserInfo({ token })
  }
  if (to.path === '/r') {
    next()
  } else {
    // if (process.env.NODE_ENV !== 'development') { // 手机在本地调试，首次登陆时把这一判断去掉
    try {
      const { token } = to.query || {}
      if (token) {
        webBridge.setUserInfo({ token })
      }
      const userInfo = JSON.parse(webBridge.getAppUserInfo())
      store.commit('setUserInfo', userInfo)
      if (window.collectEvent) {
        window.collectEvent('config', {
          dstUserName: store.getters.userInfo.realname || '',
          dstUserPhone: store.getters.userInfo.phone || '',
          dstUserId: store.getters.userInfo.id || '',
          user_unique_id: `${store.getters.userInfo.realname}_${store.getters.userInfo.phone}` // user_unique_id是预置的关键字，只要有值埋点处则标识为已登录
        })
      }
      // 设置监控的: 全局用户信息
      if (window.ArmsRum) {
        const config = window.ArmsRum.getConfig().user || {}
        setArmsConf({
          user: {
            ...config,
            name: `${store.getters.userInfo.realname}_${store.getters.userInfo.phone}` // 注意这里示例代码使用userInfo使用是因为示例的项目文件中有这个变量，如果你的项目没有这个变量，自己替换成别的变量哈
          }
        })
      }
    } catch (ex) {
      console.error('无webBridge.getUserInfo方法，请使用setUserInfo设置TOKEN')
    }
    // 权限切换开关,如果返回的是1代表思倍云权限,如果返回的是0代表车上云权限 0 - 车上云, 1 - 思倍云
    let isSpaceToggle = null
    // 如果是网页打开H5页面，则调用数据字典
    if (webBridge && webBridge.getVersionName()) {
      const res = await decision(webBridge.getVersionName() || '2.11.0')
      isSpaceToggle = res.data
    } else {
      const res = await getSimpleDictByType({ type: 'ltzs_space_toggle' })
      if (!res.data) {
        Vue.$vux.loading.hide()
        Vue.$vux.toast.show(res.msg)
        return
      }
      isSpaceToggle = !!+res.data[0].id
    }
    store.dispatch('setSpaceToggle', { isSpaceToggle })
    if (to.meta.storeKey === undefined || store.state.auth[to.meta.storeKey] && store.state.auth[to.meta.storeKey].length) {
      if (to.meta.cache && !store.state.visitedList.find(res => res === to.name)) {
        store.commit('addVisited', to.name)
      }
      next()
    } else {
      Vue.$vux.loading.show()
      if (isSpaceToggle) {
        // 获取思倍云接口,这个接口整合了php和java的权限,只需要调取一个
        const permissions = await privilegeInfoByClientId({ clientId: 'system_b19c23ec6adb78826b80d694bf83b677' })
        Vue.$vux.loading.hide()
        const obj = {}
        permissions.data.forEach((item) => {
          // 需要防止覆盖
          if (
            (!obj[item.permissionValue] && obj[item.permissionValue] !== 0) ||
            obj[item.permissionValue].length == 0
          ) {
            obj[item.permissionValue] = item.permissionValue
          }
        })
        store.dispatch('setAuth', {
          data: obj
        })
        if (obj[to.meta.storeKey] === 0) {
          Vue.$vux.toast.show('请联系平台管理员分配权限')
        } else if (to.meta.storeKey !== '*' && (!obj[to.meta.storeKey] || !obj[to.meta.storeKey].length)) {
          next({ path: '/404', replace: true }) // 暂无权限
          return
        }
        next()
        return
      }
      Promise.all([
        request.post('/trs/get-permissions'), // php的权限
        request({ url: `/dst-apis/sso/auth`, method: 'get', baseURL: '', params: { sysCode: 2 }}) // java的权限
      ])
        .then(resArr => {
          Vue.$vux.loading.hide()
          const res = resArr[0] || {}
          const obj = res.data
          // 处理java接口返回的权限
          const objTwo = resArr[1].data || {}
          const javaPermissions = objTwo.permissions || []
          javaPermissions.forEach(item => {
            // 需要防止覆盖
            if ((!obj[item.permissionValue] && obj[item.permissionValue] !== 0) || obj[item.permissionValue].length == 0) {
              obj[item.permissionValue] = item.permissionValue
            }
          })
          console.log('权限', obj)
          store.dispatch('setAuth', {
            data: obj
          })
          if (obj[to.meta.storeKey] === 0) {
            Vue.$vux.toast.show('请联系平台管理员分配权限')
          } else if (to.meta.storeKey !== '*' && (!obj[to.meta.storeKey] || !obj[to.meta.storeKey].length)) {
            next({ path: '/404', replace: true }) // 暂无权限
            return
          }
          next()
        })
        .catch(err => {
          Vue.$vux.loading.hide()
          Vue.$vux.toast.show(err.msg)
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js